import { useMemo } from 'react';
import { ESPANOL, READING } from '../../constants/applications';
import { getCurrentBenchmarkWindow, getNextBenchmarkWindow } from '../utils/assessmentWindowsUtils';

const useBMWindows = (benchmarkWindows, selectedAppGroup) => {
    // 4th period was introduced for dibels8
    // so we can receive benchmark window as for dibels
    // dibels8 application
    const windows = useMemo(
        () => ({
            [READING]: benchmarkWindows?.dibels8 ?? benchmarkWindows?.dibels,
            [ESPANOL]: benchmarkWindows?.idel,
        }),
        [benchmarkWindows],
    );

    const fourthPeriodAvailability = useMemo(
        () => ({
            [READING]: windows[READING] && Object.keys(windows[READING]).length > 3,
            [ESPANOL]: windows[ESPANOL] && Object.keys(windows[ESPANOL]).length > 3,
        }),
        [windows],
    );

    const currentBMWindow = useMemo(() => getCurrentBenchmarkWindow(windows[selectedAppGroup]), [
        windows,
        selectedAppGroup,
    ]);
    const nextBMWindow = useMemo(() => getNextBenchmarkWindow(windows[selectedAppGroup]), [
        selectedAppGroup,
        windows,
    ]);

    return {
        windows,
        currentBMWindow,
        nextBMWindow,
        fourthPeriodAvailability,
    };
};

export default useBMWindows;
